/* Forex instruments supported by the feed. */
export const FOREX_PAIRS = [
  "EURAUD", "USDCAD", "EURCAD", "USDCHF", "EURCHF", "USDJPY", "EURGBP",
  "GBPUSD", "EURJPY", "GBPAUD", "EURUSD", "GBPCHF", "AUDCAD", "GBPCAD",
  "AUDCHF", "GBPJPY", "AUDJPY", "CADCHF", "AUDUSD", "CADJPY", "CHFJPY",
];

export const OTC_PAIRS = [
  "AEDCNY_otc", "AUDCAD_otc", "AUDCHF_otc", "AUDJPY_otc", "AUDNZD_otc",
  "AUDUSD_otc", "BHDCNY_otc", "CADCHF_otc", "CADJPY_otc", "CHFJPY_otc",
  "CHFNOK_otc", "EURCHF_otc", "EURGBP_otc", "EURHUF_otc", "EURJPY_otc",
  "EURNZD_otc", "EURRUB_otc", "EURTRY_otc", "EURUSD_otc", "GBPAUD_otc",
  "GBPJPY_otc", "GBPUSD_otc", "JODCNY_otc", "KESUSD_otc", "LBPUSD_otc",
  "MADUSD_otc", "NGNUSD_otc", "NZDJPY_otc", "NZDUSD_otc", "OMRCNY_otc",
  "QARCNY_otc", "SARCNY_otc", "TNDUSD_otc", "UAHUSD_otc", "USDARS_otc",
  "USDBDT_otc", "USDBRL_otc", "USDCAD_otc", "USDCHF_otc", "USDCLP_otc",
  "USDCNH_otc", "USDCOP_otc", "USDDZD_otc", "USDEGP_otc", "USDIDR_otc",
  "USDINR_otc", "USDJPY_otc", "USDMXN_otc", "USDMYR_otc", "USDPHP_otc",
  "USDPKR_otc", "USDRUB_otc", "USDSGD_otc", "USDTHB_otc", "USDVND_otc",
  "YERUSD_otc", "ZARUSD_otc",
];

export function formatPairLabel(raw) {
  const value = String(raw ?? "");
  const isOtc = /_otc$/i.test(value);
  const normalized = value.replace(/_otc$/i, "");
  if (!normalized || normalized.length < 6) return String(raw ?? "");
  return `${normalized.slice(0, 3)}/${normalized.slice(3)}${isOtc ? " OTC" : ""}`;
}

/* Same idea as formatPairLabel, but tolerant of input that ISN'T a
   known 3+3 asset code — used for the Scanner flow, where the "pair"
   is whatever string the backend recognised from the uploaded photo
   rather than something picked from FOREX_PAIRS/OTC_PAIRS. Anything
   that doesn't look like a 6-letter base pair is shown as-is instead
   of being mangled by the strict slice(0,3)/slice(3) split. */
export function formatPairLabelSafe(raw) {
  if (!raw || typeof raw !== "string") return "";
  const normalized = raw.replace(/_otc$/i, "");
  if (!/^[A-Za-z]{6}$/.test(normalized)) return raw;
  return formatPairLabel(raw);
}